import produce from 'immer';

const INITIAL_STATE = {
  turmaSelecionada: null,
};

export default function turmas(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@videoaula/TURMA_SELECIONADA': {
        draft.turmaSelecionada = action.payload.turma;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_SUCCESS': {
        draft.turmaSelecionada = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_FAILURE': {
        draft.turmaSelecionada = null;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.turmaSelecionada = null;
        break;
      }
      default:
    }
  });
}
